
const BASE_TRANSLATION = 200;
const COL_3_BASE_TRANSLATION = 88;
const COL_4_BASE_TRANSLATION = 115;

export default class ImageTeaser {
	init() {
		const teasers = document.querySelectorAll('.buhck-imageteaser');
		for (const teaser of teasers) {
			/** @type {HTMLElement} */
			const overlay = teaser.querySelector('.overlay');
			/** @type {HTMLElement} */
			const headline = teaser.querySelector('.headline');
			if (!overlay || !headline) {
				continue;
			}
			const baseTranslation = overlay.closest('.col-md-3')
				? COL_3_BASE_TRANSLATION
				: overlay.closest('.col-md-4')
					? COL_4_BASE_TRANSLATION
					: BASE_TRANSLATION;
			const lineHeight = Number.parseInt(getComputedStyle(headline).lineHeight);
			const extraLineCount = Math.floor(headline.offsetHeight / lineHeight) - 1;
			overlay.style.transform = `translateY(calc(100% - ${baseTranslation + extraLineCount * lineHeight}px))`;
		}
	}
}
